export default function PHP_strptime() {
  return (
    <div>
      <h1>PHP_strptime</h1>
    </div>
  );
}
